<div class="flex flex-wrap items-center gap-2 mb-3 py-2">
  <!-- Search Input -->
  @if (showSearch) {
    <div class="relative flex-1 min-w-[180px] max-w-xs">
      <app-icon name="search" size="xs" class="absolute left-3 top-1/2 -translate-y-1/2 opacity-50"></app-icon>
      <input
        type="text"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInput($event)"
        placeholder="Search courses..."
        class="input input-bordered input-sm w-full pl-9 pr-8"
        data-testid="course-filter-search" />
      @if (isFiltered) {
        <button
          type="button"
          (click)="clearSearch()"
          class="clear-search-btn"
          aria-label="Clear search"
          data-testid="course-filter-clear">
          <app-icon name="close" [size]="14"></app-icon>
        </button>
      }
    </div>
  }

  <!-- Sort Controls -->
  <div class="flex items-center gap-1">
    <select
      [ngModel]="sortField"
      (ngModelChange)="onSortFieldChange($event)"
      class="select select-bordered select-sm"
      data-testid="course-filter-sort">
      @for (opt of sortOptions; track opt.value) {
        <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
    <button
      type="button"
      (click)="toggleSortOrder()"
      class="btn btn-ghost btn-sm btn-square"
      [attr.aria-label]="sortOrder === 'asc' ? 'Sort descending' : 'Sort ascending'"
      data-testid="course-filter-sort-order">
      <app-icon [name]="sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward'" size="xs"></app-icon>
    </button>
  </div>

  <!-- Result count -->
  @if (isFiltered) {
    <span class="text-xs text-base-content opacity-60" data-testid="course-filter-count">
      {{ resultCount }} of {{ totalCount }} course{{ totalCount === 1 ? '' : 's' }}
    </span>
  }
</div>
